import React from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { getUser } from "../../utils/localStorage";
import { UNIVERSAL_SEARCH_URL } from "../../utils/constants";

import ServiceDetailsTable from "../../components/ServiceRequests/ThreeSixtyDegreeView/ServiceDetailsTable";
import UserDetails from "../../components/ServiceRequests/ThreeSixtyDegreeView/UserDetails";
//import UserssDetails from "../../components/ServiceRequests/ThreeSixtyDegreeView/UserssDetails";
import { Button } from "../../common/Button/Button";

export default function ServiceDetailsContainer(props) {
	const calculateDisableMe = (services) => {
		if (services === undefined) return;
		let flag = true;
		for (let i = 0; i < services.length; i++) {
			if (services[i]["existing_service_facilitator"]) {
				if (
					services[i]["existing_service_facilitator"]["is_active"] ===
						true &&
					services[i]["existing_service_facilitator"][
						"out_of_office"
					] === false
				) {
					flag = false;
				}
				if (
				services[i]["existing_service_facilitator"]["email"] ===
						getUser().email
				)
				{
					flag = true;
				}
			}
		}

		return flag;
	};
	const renderTabs = () => {
		const {
			userDataWP,
			servicesLPMByUserId,
			servicesSPMSectionAByUserId,
			servicesSPMSectionBByUserId,
			servicesLSSortedByUserId,
		} = props;
		if (
			servicesLPMByUserId.length ||
			servicesSPMSectionAByUserId.length ||
			servicesSPMSectionBByUserId.length 
			// servicesLSSortedByUserId.length === 0
		)
			return;

		const tabHeaders = props.totalUsers.map((e, index) => {
			return <Tab>{e}</Tab>;
		});
		const tabs = props.totalUsers.map((e, index) => {
			return (
				<>
					<TabPanel>
						<div
							style={{
								display: "flex",
								flexDirection: "column",
								alignItems: "center",
								justifyContent: "center",
							}}
						>
							<div style={{ width: "85%" }}>
								<UserDetails
									data={props.userDataWP[e] ?? []}
									userData={props.userData}
									label="User Information"
								></UserDetails>
								&nbsp;&nbsp;&nbsp;
								<a href={UNIVERSAL_SEARCH_URL} target="_blank">
									Go to universal search
								</a>
							</div>
							<div style={{ width: "85%",marginTop:"10px"}}>								
							<Button 
								onClick={()=>{props.toggleViewAllNotesModal(e)}}
								style={{float:"left",marginLeft:"10px"}}
								>
								View All Notes
							</Button>
							<Button 
								onClick={()=>{props.toggleViewAllSMSModal(e)}}
								style={{float:"left",marginLeft:"10px"}}
								>
								View All SMS
							</Button>
						    </div>
							<div
								style={{
									width: "85%",
									marginBottom: "20px",
									marginTop: "20px",
									
								}}
							>
								<ServiceDetailsTable
									data={props.servicesLPMByUserId[e]}
									assignToMeClick={props.assignToMeClick}
									disableAssignToMe={calculateDisableMe(
										props.servicesLPMByUserId[e]
									)}
									nUserId={e}
									label={"Services from LPM"}
								></ServiceDetailsTable>
							</div>

							<div style={{ width: "85%",marginBottom: "10px",marginTop: "10px",}}>
								<ServiceDetailsTable
									data={props.servicesSPMSectionAByUserId[e]}
									SPMServices={true}
									toggleNotesModal={props.toggleNotesModal}
									section={"A"}
									label={
										"Services from SPM: Search matches with Service Records"
									}
								></ServiceDetailsTable>
							</div>
							<div style={{ width: "85%",marginBottom: "10px",marginTop: "10px",}}>
								<ServiceDetailsTable
									data={props.servicesSPMSectionBByUserId[e]}
									SPMServices={true}
									toggleNotesModal={props.toggleNotesModal}
									section={"B"}
									label={
										"Service from SPM: Search matches with User Profile"
									}
								></ServiceDetailsTable>
							</div>
							<div
								style={{
									width: "85%",
									marginBottom: "10px",
									marginTop: "10px",
								}}
							>
								<ServiceDetailsTable
									data={props.servicesLSSortedByUserId[e]}
									nUserId={e}
									LSServices={true}
									label={"Lead Details from LS"}
								></ServiceDetailsTable>
							</div>
						</div>
					</TabPanel>
				</>
			);
		});
		let tabHeaderContainer = (
			<>
				<Tabs>
					<TabList>{tabHeaders}</TabList>
					{tabs}
				</Tabs>
			</>
		);
		return tabHeaderContainer;
	};

	return <>{renderTabs()} </>;
}
